import dunningApi from 'api/dunning'

export default {
    namespaced: true,
    state : {
        doctype : '',
        enabled : true,
        /**
         * List of email template with id and name
         * Ex : {
         *   id: number
         *   name: string,
         * }
         */ 
        emailTemplate : [],
        /**
         * Simple list of integer for the step number day
         * Ex : [-5, -3, -1, 5, 10, 15]
         */
        daysList : [],
        /**
         * Map for hours
         * Ex : [
         *   {
         *      binary : number,
         *      hour : number,
         *   }
         * ]
         */
        hours : [],
        /**
         * Map for week days
         * Ex : [
         *   {
         *      binary : number,
         *      weekday : string, // ex : monday
         *   }
         * ]
         */
        weekDays : [],
        /**
         * Dunnings for current doctype.
         * Each obj can be contained step.
         * Ex : {
         *   id: number,
         *   main: bool, // Default plan
         *   enabled: bool,
         *   name: string,
         *   weekdays: array, // array of number
         *   hours: array, // array of number
         *   recuring: bool,
         *   gap: number,
         *   deletable: bool
         *   steps :[
         *     {
         *       id: number,
         *       name: string,
         *       days: number
         *       emailTemplateId: number,
         *       senderType: string,
         *       senderId: number,
         *       recipientType: string,
         *       recipientId: number
         *     }
         *   ]
         * }
         */
        plans : [],
        /**
         * When serveur is called
         */
        loading : false,
        /**
         * List of staff in step form.
         * Ex : {
         *   id : number,
         *   label : string, // like 'Alice - alice@local.lan'
         *   email : string
         * }
         */
        staff : []
    },
    
    mutations : {
        setDoctype (state, doctype) {
            state.doctype = doctype
        },
        setEnabled (state, enabled) {
            state.enabled = enabled
        },
        setEmailTemplate (state, emailTemplate) {
            state.emailTemplate = emailTemplate
        },
        setDaysList (state, daysList) {
            state.daysList = daysList
        },
        setHours(state, hours) {
            state.hours = hours
        },
        setWeekDays(state, weekDays) {
            state.weekDays = weekDays
        },
        setPlans (state, plans) {
            state.plans = plans
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        addPlan(state, plan) {
            state.plans.push(plan)
        },
        updatePlan(state, planForUpdate) {
            const id = planForUpdate.id
            const pos = state.plans.map(plan => plan.id).indexOf(id)
            state.plans.splice(pos, 1, planForUpdate)
        },
        deletePlan(state, planId) {
            const pos = state.plans.map(plan => plan.id).indexOf(planId)
            state.plans.splice(pos, 1)
        },

        setNoDefaultPlan(state) {
            state.plans = state.plans.map((plan) => {
                plan.main = false
                return plan
            })
        },

        /**
         * @param {Object} state 
         * @param {Object} payload with step and planId
         */
        addStep(state, payload) {
            const pos = state.plans.map(plan => plan.id).indexOf(payload.planId)
            const plan = state.plans.find(plan => plan.id == payload.planId)
            plan.steps.push(payload.step)
            state.plans.splice(pos, 1, plan)
        },
        /**
         * @param {Object} state 
         * @param {Object} payload with step and planId
         */
        updateStep(state, payload) {
            const posPlan = state.plans.map(plan => plan.id).indexOf(payload.planId)
            const plan = state.plans.find(plan => plan.id == payload.planId)
            const posStep = plan.steps.map(step => step.id).indexOf(payload.step.id)
            plan.steps.splice(posStep, 1, payload.step)
            state.plans.splice(posPlan, 1, plan)
        },
        /**
         * @param {Object} state 
         * @param {Object} payload with stepId and planId
         */
        deleteStep(state, payload) {
            const posPlan = state.plans.map(plan => plan.id).indexOf(payload.planId)
            const plan = state.plans.find(plan => plan.id == payload.planId)
            const posStep = plan.steps.map(step => step.id).indexOf(payload.stepId)
            plan.steps.splice(posStep, 1)
            state.plans.splice(posPlan, 1, plan)
        },
        setStaff(state, staff) {
            state.staff = staff
        }
    },

    actions : {
        createPlan ({ state, commit }, plan) {
            commit('setLoading', true)
            return dunningApi.createPlan(plan, state.doctype)
                .then((savedPlan) => {
                    commit('addPlan', savedPlan)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        updatePlan ({ commit }, plan) {
            commit('setLoading', true)
            return dunningApi.updatePlan(plan)
                .then((savedPlan) => {
                    commit('updatePlan', savedPlan)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        setNoDefaultPlan ({ state, commit }) {
            commit('setLoading', true)
            return dunningApi.setNoDefaultPlan(state.doctype)
                .then((nothing) => {
                    commit('setNoDefaultPlan')
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        deletePlan ({ commit }, planId) {
            commit('setLoading', true)
            return dunningApi.deletePlan(planId)
                .then((deletedPlanId) => {
                    commit('deletePlan', deletedPlanId)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },

        /**
         * @param {Object} state 
         * @param {Object} payload with step and planId
         */
        createStep ({ commit }, payload) {
            commit('setLoading', true)
            return dunningApi.createStep(payload.planId, payload.step)
                .then((step) => {
                    commit('addStep', {
                        step : step,
                        planId : payload.planId
                    })
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        /**
         * @param {Object} state 
         * @param {Object} payload with step and planId
         */
        updateStep ({ commit }, payload) {
            commit('setLoading', true)
            return dunningApi.updateStep(payload.planId, payload.step)
                .then((step) => {
                    commit('updateStep', {
                        step : step,
                        planId : payload.planId
                    })
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        deleteStep ({ commit }, payload) {
            commit('setLoading', true)
            return dunningApi.deleteStep(payload.planId, payload.stepId)
                .then((stepId) => {
                    commit('deleteStep', {
                        stepId : stepId,
                        planId : payload.planId
                    })
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        autoCompleteStaff ({ commit }, query) {
            commit('setLoading', true)
            return dunningApi.autoCompleteStaff(query)
                .then((staff) => {
                    const staffFormated = staff.map((staff) => {
                        return {
                            id: staff.id,
                            label: `${staff.fullName} - ${staff.email}`,
                            email: staff.email
                        }
                    })
                    commit('setStaff', staffFormated)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        getStaff ({ commit }, id) {
            commit('setLoading', true)
            return dunningApi.getStaff(id)
                .then((staff) => {
                    commit('setStaff', [
                        {
                            id: staff.id,
                            label: `${staff.fullName} - ${staff.email}`,
                            email: staff.email
                        }
                    ])
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },
        initDunning ({commit, state}) {
            commit('setLoading', true)
            return dunningApi.initDunning(state.doctype)
                .then((response) => {
                    commit('setPlans', response.dunnings)
                    commit('setEmailTemplate', response.templates)
                    commit('setEnabled', response.dunnings[0].enabled)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        },

        /**
         * @param {Object} commit
         * @param {Object} state
         */
        toggleStatus ({commit, state}) {
            commit('setLoading', true)
            return dunningApi.toggleStatus(state.doctype)
                .then((response) => {
                    commit('setEnabled', response.enable)
                    commit('setLoading', false)
                })
                .catch((errors) => {
                    commit('setLoading', false)
                    throw errors
                })
        }
    },

    getters: {
        getAvailableDays: (state) => (planId, stepId) => {
            const plan = state.plans.find(todo => todo.id === planId)
            const usedDays = plan.steps
                .filter(step => step.id !== stepId)
                .map(step => step.days)
            return state.daysList.filter(d => !usedDays.includes(d))
        }
    }
}
